import { nextTick } from 'vue';

const initSliderLogic = (el) => {
    const threshold = parseInt(el.dataset.width) || 600;

    // Ищем пагинацию в следующем соседнем элементе
    const paginationEl = el.nextElementSibling && el.nextElementSibling.classList.contains('slider-pagination')
        ? el.nextElementSibling
        : null;

    const dots = paginationEl ? Array.from(paginationEl.children) : [];

    const updateState = () => {

        if( window.innerWidth <= threshold ) {
            el.classList.add('slider-active');
            el.classList.remove('justify-center', 'align-center');

            // Показываем пагинацию только когда слайдер активен
            if (paginationEl) paginationEl.style.display = 'flex';
        } else {
            el.classList.remove('slider-active');
            el.classList.add('justify-center', 'align-center');

            // Скрываем пагинацию на desktop
            if (paginationEl) paginationEl.style.display = 'none';
        }
    };

    const handleScroll = () => {

        if( ! el.classList.contains('slider-active') || dots.length === 0 ) return;

        const scrollLeft = el.scrollLeft;

        // Учитываем ширину слайда (нужно точно измерить в runtime)
        const activeIndex = Math.round( scrollLeft / el.offsetWidth );

        dots.forEach(( dot, index ) => {
            dot.classList.toggle('active', index === activeIndex);
            dot.style.cursor = 'pointer';

            dot.onclick = () => {
                if( ! el.classList.contains('slider-active') ) return;

                const scrollToX = index * el.offsetWidth;

                el.scrollTo({left: scrollToX, behavior: 'smooth'});
            };
        });
    };

    el.scrollLeft = 0

    // Применяем логику активации сразу и при ресайзе
    window.addEventListener('resize', updateState);
    updateState();

    // Применяем логику скролла
    el.addEventListener('scroll', handleScroll);

    setTimeout(() => handleScroll(), 50);

    // Очистка при удалении элемента
    el._destroySlider = () => {
        window.removeEventListener('resize', updateState);
        el.removeEventListener('scroll', handleScroll);
    };
};

export default {
    install: (app) => {
        app.mixin({
            mounted() {
                nextTick(() => {
                    const sliders = document.querySelectorAll('.slide-me:not(.slider-initialized)');
                    sliders.forEach(el => {
                        el.classList.add('slider-initialized');
                        initSliderLogic(el);
                    });
                });
            },
            unmounted() {
                const sliders = document.querySelectorAll('.slide-me.slider-initialized');
                sliders.forEach(el => el._destroySlider?.());
            }
        });
    }
};